import React from 'react'
import Select from 'react-select'

interface SousBlocSelectOption {
    value: string
    label: string
}

interface TemplateFieldEditFieldsProps {
    label: string
    sousBloc: SousBlocSelectOption
    sousBlocOptions: SousBlocSelectOption[]
    disabled: boolean
    onLabelChange: (label: string) => void
    onSousBlocChange: (option: SousBlocSelectOption) => void
}

/** Édition inline (admin) du libellé et du sous-bloc d'un template_field. */
export function TemplateFieldEditFields({ label, sousBloc, sousBlocOptions, disabled, onLabelChange, onSousBlocChange }: TemplateFieldEditFieldsProps) {
    return (
        <div className="d-flex align-items-center">
            <input
                type="text"
                className="form-control form-control-sm mr-2"
                style={{ maxWidth: 220 }}
                value={label}
                onChange={e => onLabelChange(e.target.value)}
                disabled={disabled}
            />
            <div style={{ minWidth: 180 }}>
                <Select
                    value={sousBloc}
                    options={sousBlocOptions}
                    onChange={(option: SousBlocSelectOption | null) => onSousBlocChange(option || sousBlocOptions[0])}
                    clearable={false}
                    disabled={disabled}
                    placeholder="Sous-bloc"
                />
            </div>
        </div>
    )
}

interface TemplateFieldSocleCheckboxProps {
    checked: boolean
    disabled: boolean
    onChange: (checked: boolean) => void
}

/** Bascule admin du statut "champ socle" d'un template_field. */
export function TemplateFieldSocleCheckbox({ checked, disabled, onChange }: TemplateFieldSocleCheckboxProps) {
    return (
        <label className="ml-2 mb-0" style={{ cursor: 'pointer' }}>
            <input
                type="checkbox"
                className="mr-1"
                checked={checked}
                disabled={disabled}
                onChange={e => onChange(e.target.checked)}
            />
            <small>Champ socle</small>
        </label>
    )
}

interface TemplateFieldRowActionsProps {
    isEditing: boolean
    savingDetails: boolean
    onEdit: () => void
    onDelete: () => void
    onCancelEdit: () => void
}

/** Actions admin d'une ligne de champ : modifier / retirer, ou annuler l'édition en cours. */
export function TemplateFieldRowActions({ isEditing, savingDetails, onEdit, onDelete, onCancelEdit }: TemplateFieldRowActionsProps) {
    if (isEditing) {
        return (
            <button type="button" className="btn btn-link text-secondary p-0" title="Annuler cette modification" disabled={savingDetails} onClick={onCancelEdit}>
                <i className="fa fa-times" />
            </button>
        )
    }

    return (
        <>
            <button type="button" className="btn btn-link p-0 mr-2" title="Modifier le libellé / le sous-bloc" onClick={onEdit}>
                <i className="fa fa-pencil" />
            </button>
            <button type="button" className="btn btn-link text-danger p-0" title="Retirer ce champ du bloc" onClick={onDelete}>
                <i className="fa fa-trash" />
            </button>
        </>
    )
}
